import React from 'react';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { useDataFromOneCMS } from '../../fetchye/useDataFromOneCMS';

const HeaderComponent = () => {
  const heading = useDataFromOneCMS('heading');
  const subheading = useDataFromOneCMS('subheading');

  return (
    <div className="dls-white-bg">
      <div className="container width-full color-graphic-brand-logo-blue-box-text">
        <div className="row margin-auto flex flex-justify-center">
          <div className="pad-3-tb pad-lr-lg-up">
            <h1 className="header-title text-align-center dls-deep-blue heading-6 pad-1-b">
              {heading}
            </h1>
            <div
              className="dls-gray-06 header-body text-align-center body-1"
              /* eslint-disable-next-line react/no-danger -- content from oneCMS */
              dangerouslySetInnerHTML={{ __html: sanitize(subheading, { html: true }) }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderComponent;
